
const TokenKey = 'token'
const UserKey = 'user'
const System = 'system'
const OtherAppIdKey = 'otherAppId'

export default {
  setSystem (system) {
    window.sessionStorage.setItem(System, system)
  },
  getSystem () {
    return window.sessionStorage.getItem(System)
  },
  removeSystem () {
    window.sessionStorage.removeItem(System)
  },
  setOtherAppId (appId) {
    window.localStorage.setItem(OtherAppIdKey, appId)
  },
  getOtherAppId () {
    return window.localStorage.getItem(OtherAppIdKey)
  },
  getToken () {
    return window.sessionStorage.getItem(TokenKey)
  },
  setToken (token) {
    window.sessionStorage.setItem(TokenKey, token)
  },
  removeToken () {
    window.sessionStorage.removeItem(TokenKey)
  },
  getUser () {
    const user = window.sessionStorage.getItem(UserKey)
    if (!user) {
      return null
    }
    return JSON.parse(user)
  },
  setUser (user) {
    window.sessionStorage.setItem(UserKey, JSON.stringify(user))
  },
  removeUser () {
    window.sessionStorage.removeItem(UserKey)
  }
}



// WEBPACK FOOTER //
// ./src/store/store.js